import { ALIGN_TEXT } from 'adapter/in/common/widget/options';
import { WidgetType } from 'domain/entity/widget';

export type WidgetText = {
    type: WidgetType;
    description: WidgetTextDescription;
    header: WidgetTextContent;
    body: WidgetTextContent;
};

export class WidgetTextContent {
    constructor(readonly text: string, public alignText: ALIGN_TEXT) {}
}

export class WidgetTextDescription {
    constructor(readonly title: string) {}
}

class TextData implements WidgetText {
    type = WidgetType.TEXT;

    constructor(readonly header: WidgetTextContent, readonly body: WidgetTextContent, readonly description: WidgetTextDescription) {}
}

export default TextData;
